import { __ } from '@wordpress/i18n';
import { InspectorControls } from '@wordpress/block-editor';
import { addFilter } from '@wordpress/hooks';

import { PanelBody, TextControl, SelectControl, Spinner, RangeControl, ToggleControl } from '@wordpress/components';
import { useEntityRecords } from '@wordpress/core-data';

const allowedBlocks = [ 'core/query' ];


const addInspectorControl = ( BlockEdit ) => ( props ) => {

  if ( ! allowedBlocks.includes( props.name ) ) {
    return ( <BlockEdit { ...props } /> );
  }

  return (
    <>  
      <BlockEdit { ...props } />
        <InspectorControls>

          { ( props.attributes.query.postType == 'product' ) && <ProductSelector {...props }/> }
          
        </InspectorControls>
    </>
  ) 
}


const ProductSelector = ( props ) => {
  const { attributes, setAttributes } = props;
  const { query  } = attributes;
  const { order, orderBy  } = query;


  return (
    <>
     <PanelBody title={ __( 'More Options', 'aver' ) }>
      <SelectControl
        label={ __( 'Order', 'aver' ) }
        value={ order }
        options={ [
          {
            label: 'DESC',
            value: 'desc'
          },
          {
            label: 'ASC',
            value: 'asc'
          }              
        ]}
        onChange={( newvalue ) => setAttributes({  query:{ ...attributes.query, 'order': newvalue  } })	}
      /> 
          
      <SelectControl
        label={ __( 'Order By', 'aver' ) }
        value={ orderBy }
        options={ [
          {
            label: 'Rating',
            value: 'rating'
          },
          {
            label: 'Popularity',
            value: 'popularity'
          },               
          {
            label: 'Title',
            value: 'title'
          },
          {
            label: 'Date',
            value: 'date'
          }
        ]}
        onChange={( newvalue ) => setAttributes({ query:{ ...attributes.query, 'orderBy': newvalue } })	
        }
      />
     </PanelBody>  
   
    </>
  )
}


addFilter( 
  'editor.BlockEdit', 
  'core/query-product-extra', 
  addInspectorControl 
);
